export const KELVIN = "KELVIN";
export const CELSIUS = "CELSIUS";
export const FAHRENHEIT = "FAHRENHEIT";
